"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeOnLoadApple = void 0;
const src_1 = require("../..");
function braintreeOnLoadApple() {
    return __awaiter(this, void 0, void 0, function* () {
        if ((0, src_1.hasBraintreeClient)()) {
            const braintree = (0, src_1.getBraintreeClient)();
            const { tokenization_key: authorization } = (0, src_1.getBraintreeAppleCredentialsChecked)();
            try {
                const client = yield braintree.client.create({ authorization });
                const appleInstance = yield braintree.applePay.create({ client });
                (0, src_1.setBraintreeApplePayInstance)(appleInstance);
                (0, src_1.createBraintreeApple)();
            }
            catch (e) {
                if (e instanceof Error) {
                    e.name = 'ApplePayLoadingError';
                    throw e;
                }
                throw new src_1.ApplePayLoadingError(`Error loading Apple Pay: ${e}`);
            }
        }
    });
}
exports.braintreeOnLoadApple = braintreeOnLoadApple;
